"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const react_query_1 = require("@tanstack/react-query");
const antd_1 = require("antd");
const NewModel_1 = __importDefault(require("./NewModel"));
const DomainController_1 = __importDefault(require("../DomainController"));
const models_1 = require("../../services/models");
const ModelDetails_1 = __importDefault(require("./ModelDetails"));
const queryKeys_1 = __importDefault(require("../../constants/queryKeys"));
const ApplicationContext_1 = require("../../context/ApplicationContext");
const { Text, Paragraph } = antd_1.Typography;
const handleRecordAction = (_text, _a) => {
    var { modelId, modelName, modelDescription } = _a, rest = __rest(_a, ["modelId", "modelName", "modelDescription"]);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ style: { display: 'flex', flexDirection: 'column' } }, { children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.Link, Object.assign({ to: `/models/manage/${modelId}`, state: Object.assign({ modelId, modelName, modelDescription }, rest) }, { children: (0, jsx_runtime_1.jsx)(Text, Object.assign({ style: { color: 'inherit' } }, { children: modelName })) }), modelId), (0, jsx_runtime_1.jsx)(antd_1.Tooltip, Object.assign({ placement: 'bottomLeft', title: modelDescription }, { children: (0, jsx_runtime_1.jsx)(Paragraph, Object.assign({ type: 'secondary', ellipsis: { rows: 1 }, style: { maxWidth: 300, margin: 0 } }, { children: modelDescription })) }))] })));
};
const columns = [
    { title: 'Name', dataIndex: 'modelName', key: 'modelName', render: handleRecordAction },
    { title: 'Code', dataIndex: 'modelCode', key: 'modelCode' },
    { title: 'Container', dataIndex: 'canBeParent', key: 'canBeParent',
        render: (flag) => (flag ? 'Yes' : 'No'),
    },
];
const Models = () => {
    const { tableFilters, setTableFilters } = (0, ApplicationContext_1.useApplicationContext)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [searchValue, setSearchValue] = (0, react_1.useState)('');
    (0, react_1.useEffect)(() => { var _a; return setSearchValue((_a = tableFilters === null || tableFilters === void 0 ? void 0 : tableFilters.models) === null || _a === void 0 ? void 0 : _a.search); }, []);
    const { isLoading, data } = (0, react_query_1.useQuery)([queryKeys_1.default.MODELS.ALL], (0, models_1.getModels)(), {
        onError: (err) => {
            const { status, data: { msg } } = err.response;
            switch (status) {
                case 404: return navigate('/models/404', { state: { comingFrom: '' } });
                case 500: return navigate('/models/500');
                default: antd_1.message.error(msg);
            }
        },
    });
    const handleSearch = (value) => {
        setSearchValue(value);
        setTableFilters(Object.assign(Object.assign({}, tableFilters), { models: Object.assign(Object.assign({}, tableFilters.models), { search: value }) }));
    };
    return ((0, jsx_runtime_1.jsx)(DomainController_1.default, { apiContext: '/models', urlPath: '/models', loading: isLoading, columns: columns, data: data, title: 'Models', componentForNew: (0, jsx_runtime_1.jsx)(NewModel_1.default, {}), componentForManage: (0, jsx_runtime_1.jsx)(ModelDetails_1.default, {}), primaryKey: 'modelId', searchBy: 'modelName' // add a valid key for client side searching
        , searchText: searchValue, handleSearch: handleSearch }));
};
exports.default = Models;
